export const defineKey = (arg: string) => arg;
